/**
 * 
 * @author 
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

 import ServicePath from "@/core/ServicePath";
 import {
     MainRequest
 } from "@/core/request";
 import axios from 'axios';
 
 export default class CategoryRequest extends MainRequest{
 
     static addCategory(data) {
         return this.postSEC(ServicePath.CATEGORY_ADD, data)
     }
 
     static listAllCategory() {
         return this.getSEC(ServicePath.CATEGORY_LIST_ALL)
     }
 
     static updateCategory(data) {
         return this.postSEC(ServicePath.CATEGORY_UPDATE, data)
     }
 
     static deleteCategory(data) {
         return this.postSEC(ServicePath.CATEGORY_DELETE, data)
     }
 
 }